import React, { useContext } from "react"
import { useSelector } from "react-redux"
import { testTakerRQ } from "store/hooks"
import { CreateTestTakersContext } from "../CreateTestTakerContext"
import { createAffiliationHooks } from "pages/School/CreateAffiliation"
import allClassess from "mock/classess"

const useFormFields = () => {
    const { grades } = useSelector(state => state.testTaker)
    const { schools } = useContext(CreateTestTakersContext)

    const { data: allGrades } = testTakerRQ.useGetAllGrades({ enabled: true })

    const affiliationField = createAffiliationHooks.useAffiliationField(schools)

    const fields =
        React.useMemo(
            () =>
                [
                    {
                        ...affiliationField,
                        minWidth: 100,
                        fullWidth: true
                    },
                    {
                        name: "grade",
                        placeholder: "שכבה",
                        minWidth: 100,
                        component: "autoComplete",
                        className: "_child__grade",
                        systemUI: true,
                        options: allGrades,
                        required: true
                    },
                    {
                        name: "school_class",
                        placeholder: "מספר כיתה",
                        minWidth: 100,
                        component: "autoComplete",
                        className: "_child__t_class",
                        systemUI: true,
                        options: allClassess,
                        required: true,
                        isOptionEqualToValue: (option, value) => option.id === value.id
                    },
                    {
                        name: "file",
                        component: "uploadFile",
                        label: "רשימת התלמידים בפורמט exel",
                        type: "exel",
                        showCleanIcon: true
                    }
                ]
            , [grades, schools, allGrades]
        );


    return fields
}

export default useFormFields 